import './styles.scss';
import ButtonCustom from '../../../common/__deprecated__/button-custom';
import { useRefunds } from '../../../../store/refunds';
import DialogExportRefunds from './dialog';
import l from '../../../../lang';
import { ReactComponent as DownloadIcon } from '../../../../assets/icons/file-download.svg';
import { segmentTransactionsDownloadReport } from '../../../../utils/analytics';

const ExportRefunds = () => {
  const { showExportRefunds } = useRefunds();
  return (
    <>
      <DialogExportRefunds />
      <div className="export_transactions__top_button">
        <ButtonCustom
          text={<span className="export_transactions__top_button__text">{l('exportRefunds.open')}</span>}
          onClick={() => {
            segmentTransactionsDownloadReport();
            showExportRefunds(true);
          }}
          variant="outlined"
          startIcon={<DownloadIcon className="export_transactions__top_button__icon" />}
          fullWidth
        />
      </div>
    </>
  );
};

export default ExportRefunds;
